import { productFeatures } from "@/lib/product-features";
import { AppDownload } from "./app-download";
import { CategoryGrid } from "./category-grid";
import { FeaturedStudios } from "./featured-studios";
import { ForPros } from "./for-pros";
import { HeroSection } from "./hero-section";

function HomePage() {
  return (
    <>
      <HeroSection />
      <CategoryGrid />
      <FeaturedStudios />
      <ForPros />
      {productFeatures.appDownload && <AppDownload />}
    </>
  );
}

export { HomePage };
